import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import Textlink from '@xingternal/malt-textlink';

import BlacklistedImage from './../../Components/Illustrations/BlacklistedImage';
import { CustomH, CustomP } from './../../Components/CustomMalt/Typography';

import messages from './messages';
import styles from './Blacklisted.css';

const buildLink = (href, text) => <Textlink href={href}>{text}</Textlink>;

const Blacklisted = ({ intl }) => (
  <>
    <BlacklistedImage />
    <CustomH>
      <FormattedMessage {...messages.salutation} />
    </CustomH>
    <CustomP>
      <FormattedMessage {...messages.paragraph1} />
    </CustomP>
    <CustomP>
      <FormattedMessage {...messages.paragraph2} />
    </CustomP>
    <CustomP className={styles.emailLink}>
      {buildLink(
        intl.formatMessage(messages.paragraph2linkTarget),
        intl.formatMessage(messages.paragraph2linkText)
      )}
    </CustomP>
    <CustomP>
      <FormattedMessage
        {...messages.paragraph3}
        values={{
          helpCenterLink: buildLink(
            intl.formatMessage(messages.paragraph3linkTarget),
            intl.formatMessage(messages.paragraph3linkText)
          ),
        }}
      />
    </CustomP>
  </>
);

Blacklisted.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Blacklisted);
